import script from "./StoreTableDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreTableDialog.vue?vue&type=script&setup=true&lang=ts"

import "./StoreTableDialog.vue?vue&type=style&index=0&id=2a40a8b7&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a40a8b7"]])

export default __exports__